module.exports = __webpack_public_path__ + "img/respro-logo.2b744658.svg";